import React from "react";

export default function GestorPanel({
  session,
  farms: allFarms,
  onLogout,
  onSessionUpdate,
  themeRevision,
  deps = {},
}) {
  const {
    isFarmArchived,
    T,
    SyncStatusBar,
    FarmCtx,
    FarmDashboard,
    farmDashboardDeps,
    FarmEmoji,
    fmtDate,
  } = deps;

  const activeFarms = (allFarms || []).filter((farm) => !isFarmArchived(farm));
  const myFarms = session?.farmIds?.length === 0
    ? activeFarms
    : activeFarms.filter((farm) => (session?.farmIds || []).includes(farm.id));

  const [activeFarm, setActiveFarm] = React.useState(myFarms.length === 1 ? myFarms[0] : null);

  React.useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const openFromPayload = (payload = {}) => {
      const module = String(payload?.module || "").trim().toLowerCase();
      const farmId = String(payload?.farmId || "").trim();
      const recordId = String(payload?.orderId || payload?.recordId || "").trim();
      if (!recordId || !farmId) return false;
      if (!(module === "purchases" || module === "orders" || !module)) return false;
      const farm = myFarms.find((item) => String(item?.id || "") === farmId);
      if (!farm) return false;
      setActiveFarm(farm);
      return true;
    };
    try {
      const raw = sessionStorage.getItem("fz:pendingLiveActivityDeepLink");
      const payload = raw ? JSON.parse(raw) : null;
      openFromPayload(payload);
    } catch (_) {}
    const onLiveOpen = (event) => { try { openFromPayload(event?.detail || {}); } catch (_) {} };
    window.addEventListener("fz:live-activity-open-record", onLiveOpen);
    return () => window.removeEventListener("fz:live-activity-open-record", onLiveOpen);
  }, [myFarms]);


  if (activeFarm) {
    return (
      <FarmCtx.Provider value={{ fid: activeFarm.id, farm: activeFarm }}>
        <FarmDashboard
          farm={activeFarm}
          session={session}
          isGestor={true}
          themeRevision={themeRevision}
          onBack={() => setActiveFarm(null)}
          onLogout={onLogout}
          onSessionUpdate={onSessionUpdate}
          deps={farmDashboardDeps}
        />
      </FarmCtx.Provider>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: T.bg, fontFamily: "'DM Sans',sans-serif", color: T.text }}>
      <div
        style={{
          background: T.card,
          borderBottom: `1px solid ${T.border}`,
          padding: "16px 24px",
          paddingTop: "max(16px, env(safe-area-inset-top))",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 50,
        }}
      >
        <div>
          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 700, color: T.text }}>
            Olá, {session.name} 🔐
          </div>
          <div style={{ fontSize: 12, color: T.muted, marginTop: 2 }}>Gestor</div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <SyncStatusBar inline />
          <button
            onClick={onLogout}
            style={{
              background: "none",
              border: `1px solid ${T.border}`,
              color: T.muted,
              cursor: "pointer",
              borderRadius: 8,
              padding: "6px 12px",
              fontSize: 12,
            }}
          >
            Sair
          </button>
        </div>
      </div>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "28px 20px" }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: T.muted, marginBottom: 12 }}>
            {myFarms.length} fazenda(s) sob sua gestão. Clique para acessar.
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14 }}>
            {myFarms.map((farm) => (
              <div
                key={farm.id}
                onClick={() => setActiveFarm(farm)}
                style={{
                  background: T.card,
                  border: `2px solid ${T.border}`,
                  borderRadius: 14,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "all .2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = farm.color;
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = T.border;
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div style={{ background: `${farm.color}22`, padding: "20px", display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 14,
                      background: `${farm.color}33`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FarmEmoji farm={farm} size={26} />
                  </div>
                  <div>
                    <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 700, color: T.text }}>
                      {farm.name}
                    </div>
                    <div style={{ fontSize: 12, color: T.muted, marginTop: 2 }}>
                      Criada em {fmtDate(farm.createdAt)}
                    </div>
                  </div>
                </div>
                <div style={{ padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 13, color: farm.color, fontWeight: 600 }}>Acessar módulos →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {myFarms.length === 0 && (
          <div style={{ color: T.muted, textAlign: "center", padding: 40 }}>
            Nenhuma fazenda atribuída. Contate o administrador.
          </div>
        )}
      </div>
    </div>
  );
}
